module.exports = __webpack_public_path__ + "media/theme/icon__psn-37ef1458.svg";